import { inject, Injectable } from '@angular/core';
import { EtlService } from '@services/etl.service';
import { Store } from '@services/store';
import { EtlRoute } from '@shared/models/etl-route.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EtlRoutesStore extends Store<EtlRoute[]> {
  private readonly service = inject(EtlService);

  protected getDataSource(key: string): Observable<EtlRoute[]> {
    return this.service.getRoutes(key as any);
  }
}
